import { styled } from "@stitches/react";

export const SearchInput = styled("input", {
  // base styles
  width: "100%",
  border: "0",
  outline: "none",
  letterSpacing: "-0.03rem",
  variants: {},
});
